import { render, staticRenderFns } from "./NewSector.vue?vue&type=template&id=2bdf816a&lang=html&"
import script from "./NewSector.vue?vue&type=script&lang=js&"
export * from "./NewSector.vue?vue&type=script&lang=js&"
import style0 from "./NewSector.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports